import styled from 'styled-components';

import { lineClamp } from '@/utils/line-clamp';

export const LineClampOne = styled.div`
  ${lineClamp(1)};
`;

export const LineClampTwo = styled.div`
  ${lineClamp(2)};
`;
